import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import oluseun from "../../../assets/images/oluseun.jpg";
import joseph from "../../../assets/images/joseph.jpg";
import rose from "../../../assets/icons/rose.jpg";

const council = [
  {
    name: "Oluseun Onigbinde",
    title: "Fund Lead & Co-founder,BudgIT",
    profile:
      "Oluseun Onigbinde is an award-winning public data visualization expert and open government advocate and co-founder of BudgIT, the leading fiscal transparency & data visualization organization in Nigeria. Since 2011, he has worked to strengthen fiscal transparency in Nigeria, building a reputation for public sector efficiency. His organization has reached over 12 million Nigerians and also support over 45 civil society organizations and public institutions such as NEITI, National Assembly, Nigerian Investment Promotion Commission and Kaduna State Government. Oluseun is a recipient of over 10 international awards.",
    profile2:
      "Oluseun Onigbinde chairs the Citizen's Gavel Board and is also a member of the board of trustees for SustyVibes & Eduplana. In 2018, Oluseun Onigbinde was selected by the Obama Foundation for its inaugural Obama Scholars Program at Columbia University.",
    imgpath: oluseun,
  },
  {
    name: "Rose Maruru",
    title: "Director, EPIC Africa",
    profile:
      "Rose Maruru is the Co-Founder and Director of Operations at EPIC-Africa, an organization dedicated to strengthening philanthropy in Africa by addressing critical data and capacity gaps. With extensive experience in nonprofit management and philanthropy, she has played a key role in supporting the growth of a resilient and impactful civil society sector across the continent.",
    profile2:
      "Before co-founding EPIC-Africa, Rose held leadership roles in various philanthropic initiatives, focusing on capacity building, strategic funding, and sector-wide development. Her work continues to drive innovation and sustainability in African philanthropy, empowering organizations to maximize their impact.",
    imgpath: rose,
  },
  {
    name: "Joseph Amenaghawon",
    title: "Civic Hive Lead & former Program Manager, Open Society Foundations",
    profile:
      "Joseph Idahosa Amenaghawon is the Strategy and Growth Advisor at BudgiT Foundation. In the last twelve years, he served as the Economic Governance/ Justice Coordinator at the Open Society Initiative for West Africa (OSIWA), where he was actively involved in supporting strategy design and implementation, grant making and grantees supervision, project management, monitoring, evaluation and learning.",
    profile2:
      " Joseph is currently a Doctorate candidate in Development Studies at Atlantic International University. He holds a master’s degree in international law and Diplomacy (MILD) and a bachelor’s degree in Economics.  He has also attended several professional and leadership training courses, including the prestigious Harvard Kennedy School.",
    imgpath: joseph,
  },
];

const Leadership = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      padding={{ xs: "30% 0% 5% 0%", sm: "2% 0% 2% 0%" }}
      spacing={1}
    >
      <Grid item xs={12} sm={12}>
        <Box
          width={{ xs: "100%", sm: "60%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={700}
            textAlign={"left"}
            color={"#39484E"}
            paddingBottom={"5%"}
          >
            Leadership Team
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        flexWrap={"wrap"}
        marginTop={"1%"}
      >
        {council.map((advisory, index) => {
          const { name, imgpath, title } = advisory;
          return (
            <Grid>
              <Grid
                key={index}
                item
                xs={12}
                md={4}
                marginBottom={{ xs: "10%", sm: "5%" }}
                marginRight={{ xs: "0%", sm: "1%" }}
                marginLeft={{ xs: "0%", sm: "0%" }}
                display={{ xs: "none", sm: "block" }}
              >
                <Card
                  sx={{
                    minWidth: 380,
                    maxWidth: 380,
                    height: "100%",
                    bgcolor: "#fff",
                  }}
                >
                  <CardMedia
                    component="img"
                    height="320"
                    image={imgpath}
                    sx={{ objectFit: "cover" }}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#39484E"}
                      fontWeight={700}
                      paddingTop={"4%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"4%"}
                      variant="body1"
                      color="#000"
                      fontWeight={700}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid
                key={index}
                item
                xs={12}
                md={4}
                marginBottom={{ xs: "10%", sm: "5%" }}
                marginRight={{ xs: "0%", sm: "1%" }}
                marginLeft={{ xs: "0%", sm: "0%" }}
                display={{ xs: "block", sm: "none" }}
              >
                <Card
                  sx={{
                    minWidth: 330,
                    maxWidth: 330,
                    height: "100%",
                    bgcolor: "#fff",
                  }}
                >
                  <CardMedia
                    component="img"
                    height="320"
                    image={imgpath}
                    sx={{ objectFit: "cover" }}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#39484E"}
                      fontWeight={700}
                      paddingTop={"4%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"4%"}
                      variant="body1"
                      color="#000"
                      fontWeight={700}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Leadership;
